export interface IResaleReport {
  id: number;
  code: string;
  name: string;
}
